"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
import * as handlers2 from "components/Overlay/handlers.js";
export const bindActions = function bindActions() {
  $(Dom.imageSlider).on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      handlers.checkForVideo(event, slick, currentSlide, nextSlide);
    },
  );
  $(".product-thumbnails .slick-slide").each(function (i, elm) {
    var ariaValue = elm.getAttribute("aria-hidden");
    if (ariaValue == "true") {
      elm.removeAttribute("tabindex");
    }
  });
  $(Dom.productImage).on("click", function () {
    handlers.openProductModal($(this));
  });
  $(Dom.productModal).on("click", function () {
    handlers.closeProductModal();
    handlers2.hideOverlay();
  });
};
